import React from "react";
import {
  FaBullseye,
  FaEye,
  FaBuilding,
  FaUsers,
  FaProjectDiagram,
} from "react-icons/fa";

function About() {
  return (
    <div
      id="/about"
      className="bg-gradient-to-r from-indigo-400 to-purple-600 text-gray-900 p-8 min-h-screen"
    >
      <div className="container mx-auto py-10">
        <h1 className="text-4xl font-bold text-center mb-8 text-white">
          About Us
        </h1>

        {/* Company Information */}
        <div className="bg-white bg-opacity-75 rounded-lg p-8 mb-8 flex items-start transform hover:scale-105 transition duration-300 ease-in-out">
          <FaBuilding className="text-6xl text-indigo-500 mr-6" />
          <div>
            <h2 className="text-3xl font-bold mb-4">Our Company</h2>
            <p className="text-lg">
              At MyService, we specialize in delivering top-notch UI/UX design,
              web development, and app development services. Our goal is to help
              businesses succeed by creating visually appealing and highly
              functional digital experiences.
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="bg-white bg-opacity-75 rounded-lg p-8 mb-8 flex items-start transform hover:scale-105 transition duration-300 ease-in-out">
          <FaBullseye className="text-6xl text-indigo-500 mr-6" />
          <div>
            <h2 className="text-3xl font-bold mb-4">Our Mission</h2>
            <p className="text-lg">
              Our mission is to empower businesses with innovative and
              user-friendly digital solutions that enhance customer engagement
              and drive growth. We strive to exceed client expectations by
              delivering high-quality services tailored to their unique needs.
            </p>
          </div>
        </div>

        {/* Vision */}
        <div className="bg-white bg-opacity-75 rounded-lg p-8 mb-8 flex items-start transform hover:scale-105 transition duration-300 ease-in-out">
          <FaEye className="text-6xl text-indigo-500 mr-6" />
          <div>
            <h2 className="text-3xl font-bold mb-4">Our Vision</h2>
            <p className="text-lg">
              Our vision is to be a leading provider of digital solutions
              globally, known for our commitment to excellence and customer
              satisfaction. We aim to continuously innovate and adapt to the
              changing technological landscape to provide the best possible
              outcomes for our clients.
            </p>
          </div>
        </div>

        {/* Clients */}
        <div className="bg-white bg-opacity-75 rounded-lg p-8 flex items-start justify-around transform hover:scale-105 transition duration-300 ease-in-out">
          <div className="text-center">
            <FaUsers className="text-6xl text-indigo-500 mb-4" />
            <h2 className="text-3xl font-bold mb-2">100+</h2>
            <p className="text-lg">Clients Served</p>
          </div>
          <div className="text-center">
            <FaProjectDiagram className="text-6xl text-indigo-500 mb-4" />
            <h2 className="text-3xl font-bold mb-2">200+</h2>
            <p className="text-lg">Projects Completed</p>
          </div>
          <div className="text-center">
            <FaUsers className="text-6xl text-indigo-500 mb-4" />
            <h2 className="text-3xl font-bold mb-2">150+</h2>
            <p className="text-lg">Ongoing Projects</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
